<template>
  <a class="icon-progreso" :class="habilitado ? 'icon-progreso-habilitado' : ''" @click="irA()" >
    <div class="icon-progreso-imagen icon-progreso-imagen-editar" :class="['icon-progreso-imagen-' + tipo, 'icon-progreso-imagen-grayscale-' + grayscale]">
      <svg class="icon-progreso-imagen-porcentaje" xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 33.3 33.3' :stroke-dasharray="progreso" ><circle cx='16.65' cy='16.65' r='15.9155' fill='none' /></svg>
    </div>
    <span class="icon-progreso-descripcion">{{ descripcion }}</span>
  </a>
</template>

<script>

export default {
  props: ['tipo'],
  computed: {   
    habilitado() {
      switch(this.tipo) {        
        case "registro":  
          if(!this.$store.getters.userId) {
            return true
          } else {
            return false
          }

          break
        
        case "informacionBasica":
          if(!this.$store.getters.userId) {
            return false
          }else{
            return true
          }
          break

        default:  
          if(this.$store.getters.cliente) {
            return true
          }        
          break
      }

      return false
    },
    porcentaje() {

      let valorPuntaje = null
      let puntajeActual = null

      switch(this.tipo) {
        case "registro":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.registro
          puntajeActual = this.$store.getters.puntajeActual.registro          
          break

        case "informacionBasica":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.informacionBasica
          puntajeActual = this.$store.getters.puntajeActual.informacionBasica          
          break
        
        /*case "fechaNacimiento":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.fechaNacimiento
          puntajeActual = this.$store.getters.puntajeActual.fechaNacimiento          
          break*/

        case "estadoCivil":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.estadoCivil
          puntajeActual = this.$store.getters.puntajeActual.estadoCivil          
          break

        case "contacto":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.contacto
          puntajeActual = this.$store.getters.puntajeActual.contacto          
          break

        case "direccion":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.direccion
          puntajeActual = this.$store.getters.puntajeActual.direccion          
          break

        case "categorias":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.categorias
          puntajeActual = this.$store.getters.puntajeActual.categorias          
          break

        case "medioTransporte":  
          valorPuntaje = this.$store.getters.puntajeDatosCliente.medioTransporte
          puntajeActual = this.$store.getters.puntajeActual.medioTransporte          
          break
      }

      if(!puntajeActual || !valorPuntaje) {
        return 0
      }
      else {
        return Math.floor((puntajeActual / valorPuntaje.valor) * 100.0)
      }      
    },
    descripcion() {
      switch(this.tipo) {
        case "registro":  
          return "Registro"

        case "informacionBasica":  
          return "Bienvenidos"
        
        //case "fechaNacimiento":  
        //return "Cumpleaños"

        case "estadoCivil":  
          return "Estado Civil"

        case "contacto":  
          return "Contacto"

        case "direccion":  
          return "Dirección"

        case "categorias":  
          return "Conociéndonos"

        case "medioTransporte":  
          return "Transporte"
        case "factura":
          return "Factura"
        default:
          return ''
      }
    },
    progreso() {
      return '' + this.porcentaje + ', 100'
    },
    grayscale ()
    {
      return 100 - this.porcentaje
    }
  },
  methods: {
    irA() {
      if(!this.habilitado)
      {
        return
      }

      let name = ''

      switch(this.tipo) {
        case "registro":  
          name = 'login'  
          break

        case "informacionBasica":  
          name = 'completar-registro'
          break
        
       // case "fechaNacimiento":  
        // name = 'fecha-nacimiento'         
        // break

        case "estadoCivil":  
          name = 'estado-civil'          
          break

        case "contacto":  
          name = 'contacto'      
          break

        case "direccion":  
          name = 'direccion'    
          break

        case "categorias":  
          name = 'categorias'      
          break

        case "medioTransporte":  
          name = 'transporte'          
          break
        case "factura":
          name = 'subir-factura'
          break
      }

      if(name.length > 0)
      {
        this.$router.push({ name })
      }
    }
  }
}
</script>
